export default __webpack_public_path__ + "static/media/Sealants-Gif.85117a24.gif";